<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/WUJwKA/tc-custom/9781460349526.jpg?1743839653130" alt="This image is the cover for the book Mistress Below Deck"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mistress Below Deck
      </h1>
      <p class="bookDescription body article font2">
        <p>Kidnap, deceptionand forbidden desire<br/><br/>Tobias Searle’s ship is no place for a ladyespecially one as wilful and spirited as Miss Rowena Golding. Tobias is chasing pirates, she her kidnapped sisterand the price to board his ship is one night in his bed! Rowena despises Tobias’s arrogance, is immune to his lethal charm, and certainly doesn’t quiver at his touchher stubbornness wouldn’t allow it! But she’s boarding that ship come what may. Masquerading as a cabin boy, she’s prepared for the dangers of the high seasbut is she prepared for the notorious Tobias Searle?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Helen Dickson
      </h2>
      
      <p class="authorDescription body article">Helen Dickson lives in South Yorkshire with her retired farm manager husband. On leaving school she entered the nursing profession, which she left to bring up a young family. Having moved out of the chaotic farmhouse, she has more time to indulge in her favourite pastimes. She enjoys being outdoors, travelling, reading and music. An incurable romantic, she writes for pleasure. It was a love of history that drove her to writing historical romantic fiction.&#160;&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Mills and Boon
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0ac3cef8